import Spinner from 'react-bootstrap/Spinner'

const LoadingSpinner = () => (
    <Spinner animation="border" role="status" variant="primary"></Spinner>
)

export default LoadingSpinner
